module.exports = __webpack_public_path__ + "img/social-grid-rzr-mp.4f4c3a3.jpg";